export const config = {
  rowSelection: false,
  tableType: 'antd',
  columns: [
    {
      title: '分公司',
      dataIndex: 'companyName',
      width: 160,
      fixed: 'left',
    },
    {
      title: '推送量',
      dataIndex: 'questionnaireSendSize',
      width: 160,
    },
    {
      title: '问卷回收数量',
      dataIndex: 'questionnaireSize',
      width: 160,
    },
    {
      title: '满意数',
      dataIndex: 'satisfactionSize',
      width: 100,
    },
    {
      title: '满意率(%)',
      dataIndex: 'satisfactionRate',
      width: 140,
    },
    {
      title: 'NPS推荐数',
      dataIndex: 'npsRecommendSize',
      width: 120,
    },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      width: 130,
      render: 'operationFn',
    },
  ],
  search: [
    {
      name: 'companyId',
      label: '分公司',
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'companyList',
      allowClear: true,
    },
    {
      name: 'date',
      label: '评价时间',
      placeholder: ['评价时间起', '止'],
      span: 140,
      itemType: 'autoDate',
      showTime: 'true',
    },
  ],
  footer: [
    {
      label: '导出',
      type: 'primary',
      status: ['loading:exportLoading'],
      events: ['onClick:onExport'],
    },
  ],
};